import { React } from 'react';
import styled, { keyframes } from 'styled-components';

import DefaultProfile from '../../../image/DefaultProfile.png';
import Image from '../../../Component/Share/Image';
import PhoneInput from './PhoneInput';

export default function DuplicateMemberSelectView(props) {
  const {
    duplicateMembers,
    lastPhone,
    onClickMyInfo,
    close
  } = props;

  return (
    <TopLevelWrapper>
      <ExplanationWrapper>
        <ExplanationText color='#FF8B48'>중복된 번호입니다</ExplanationText>
        <ExplanationText color='#FF8B48'>회원님의 프로필을 선택해주세요</ExplanationText>
      </ExplanationWrapper>
      <InputWrapper>
        <PhoneInput value={lastPhone} />
      </InputWrapper>
      <MemberInfoTotalWrapper>
          {
            duplicateMembers.map((data, index) => (
              <MemberInfoWrapper key={index} onClick={() => onClickMyInfo(data)}>
                <ProfileWrapper>
                  <ProfileBox>
                    <Image src={data.profile} defaultSrc={DefaultProfile}/>
                  </ProfileBox>
                </ProfileWrapper>
                <TextInfoWrapper>
                  <InfoTotalWrapper>
                    <MemberNameWrapper>
                      <NameText fontFmaily='NotoSansKR-Bold' color='#000000'>{data.userName}</NameText>
                      <NameText fontFmaily='NotoSansKR-Regular' color='#777777'>회원</NameText>
                    </MemberNameWrapper>
                    <TextColumnBoxWrapper>
                      <TextColumnBox>
                        <NameText fontFmaily='NotoSansKR-Regular' color='#CBCBCB'>성별</NameText>
                      </TextColumnBox>
                      <TextColumnBox>
                        <NameText fontFmaily='NotoSansKR-Medium' color='#595959'>{data.gender === 'male' ? '남성' : '여성'}</NameText>
                      </TextColumnBox>
                    </TextColumnBoxWrapper>
                    <TextColumnBoxWrapper>
                      <TextColumnBox>
                        <NameText fontFmaily='NotoSansKR-Regular' color='#CBCBCB'>링코 ID</NameText>
                      </TextColumnBox>
                      <TextColumnBox>
                        <NameText fontFmaily='NotoSansKR-Medium' color='#595959'>{data.nickName}</NameText>
                      </TextColumnBox>
                    </TextColumnBoxWrapper>
                    <TextColumnBoxWrapper>
                      <TextColumnBox>
                        <NameText fontFmaily='NotoSansKR-Regular' color='#CBCBCB'>락커 번호</NameText>
                      </TextColumnBox>
                      <TextColumnBox>
                        <NameText fontFmaily='NotoSansKR-Medium' color='#595959'>{data.lockerName}</NameText>
                      </TextColumnBox>
                    </TextColumnBoxWrapper>
                  </InfoTotalWrapper>
                </TextInfoWrapper>
              </MemberInfoWrapper>
            ))
          }
      </MemberInfoTotalWrapper>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  box-sizing: border-box;

  // width: 78.5%;
  // height: 92.93%;
  width: 100%;
  height: 100%;

  padding: 3.535% 10.75%;

  margin-top: 28px;

  z-index: 1;

	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 43px;

  width: 100%;

  gap: 4px;
`;

const ExplanationText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 17px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 17px;
  }
  @media (min-height: 640px) {
    font-size: 18px;
  }
  @media (min-height: 720px) {
    font-size: 19px;
  }
  @media (min-height: 760px) {
    font-size: 20px;
  }
  @media (min-height: 800px) {
    font-size: 22px;
  }
  @media (min-height: 1000px) {
    font-size: 28px;
  }
  @media (min-height: 1200px) {
    font-size: 32px;
  }

  &:hover {
    cursor: default;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 80.6%;

  gap: 8px;
  margin-top: 34px;
  padding: 12px 0px 12px 0px;

  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #FF8B48;

  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #FF8B48;

  @media (min-height: 320px) {
    gap: 4px;
  }
  @media (min-height: 640px) {
    gap: 6px;
  }
  @media (min-height: 720px) {
    gap: 8px;
  }
`;


const MemberInfoTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 34px;

  width: 100%;
  height: 50%;

  gap: 20px;

  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: #777777 transparent;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #777777;
    border-radius: 4px;
  }

  transition: all 0.3s ease-in-out
`;

const MemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const ProfileWrapper = styled.div`
  position: relative;

  width: 32.8%;

  &::after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`;

const ProfileBox = styled.div`
  position: absolute;

  width: 100%;
  height: 100%;

  border-radius: 10px;

  overflow: hidden;
`;

const TextInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // width: 61.74%;
  width: 65.74%;
  height: 100%;

  background-color: #FFFFFF;
  // box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  // box-shadow: 0px 40px 50px rgba(10, 10, 10, 0.5);

  border-radius: 10px;
  border: 1px solid #DFDFDF;
`;

const InfoTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: flex-start;

  width: 87%;
  height: 90%;

  @media (min-height: 320px) { padding: 0px 0px; }
  @media (min-height: 640px) { padding: 2px 0px; }
  @media (min-height: 720px) { padding: 2px 0px; }
  @media (min-height: 800px) { padding: 0px 0px; }
  @media (min-height: 1000px) { padding: 2px 0px; }
  @media (min-height: 1200px) { padding: 20px 0px; }
`;

const MemberNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 4px;

  overflow: hidden;

  & > p:first-child {
    width: auto;
    min-width: 0;
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & > p:last-child {
    width: auto;
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

const TextColumnBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  & > div:first-child {
    width: 5em;
    flex-shrink: 0;
  }

  & > div:last-child {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }
`;

const TextColumnBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 47.2%;

  overflow: hidden;
`;

const NameText = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: 13px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media (min-height: 320px) {
    font-size: 12px;
  }
  @media (min-height: 640px) {
    font-size: 13px;
  }
  @media (min-height: 720px) {
    font-size: 14px;
  }
  @media (min-height: 760px) {
    font-size: 15px;
  }
  @media (min-height: 800px) {
    font-size: 16px;
  }
  @media (min-height: 1000px) {
    font-size: 17px;
  }
  @media (min-height: 1200px) {
    font-size: 18px;
  }

  &:hover {
    cursor: default;
  }
`;
